import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface ClearWeekDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => Promise<void>
}

export function ClearWeekDialog({ open, onOpenChange, onConfirm }: ClearWeekDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Weekplanning wissen</DialogTitle>
          <DialogDescription>
            Alle geplande diners van deze week worden verwijderd. Deze actie kun je niet automatisch ongedaan maken.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuleren
          </Button>
          <Button variant="destructive" onClick={() => void onConfirm()}>
            Week wissen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
